import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const SpacingIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21 3H3M21 21H3M12 7V17M12 7L9 10M12 7L15 10M12 17L9 14M12 17L15 14"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

SpacingIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(SpacingIcon);
